<template>
  <div class="game-rematch-dialog-backdrop">
    <section ref="dialog" class="game-rematch-dialog" role="dialog" aria-modal="true" aria-labelledby="game-rematch-dialog-title" @keydown="onKeydown">
      <span class="game-rematch-dialog__eyebrow">Ещё одна дуэль?</span>
      <h2 id="game-rematch-dialog-title">{{ sent ? 'Ждём ответа' : `${opponentName} предлагает реванш` }}</h2>
      <p role="timer">Осталось {{ seconds }} с</p>
      <AppButton v-if="sent" block variant="secondary" :disabled="busy" @click="$emit('cancel')">Отменить запрос</AppButton>
      <template v-else>
        <AppButton block :disabled="busy" @click="$emit('accept')">Принять</AppButton>
        <AppButton block variant="secondary" :disabled="busy" @click="$emit('decline')">Отказаться</AppButton>
      </template>
    </section>
  </div>
</template>
<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import AppButton from "@/components/ui/AppButton.vue";
defineProps({
  sent: { type: Boolean, default: false }, busy: { type: Boolean, default: false },
  opponentName: { type: String, default: "Соперник" }, seconds: { type: Number, default: 15 },
});
defineEmits(["accept", "decline", "cancel"]);
const dialog = ref(null);
let previousFocus;
onMounted(() => { previousFocus = document.activeElement; dialog.value.querySelector("button")?.focus(); });
onBeforeUnmount(() => { if (previousFocus?.isConnected) previousFocus.focus(); });
function onKeydown(event) {
  if (event.key !== "Tab") return;
  const buttons = [...dialog.value.querySelectorAll("button:not(:disabled)")];
  if (!buttons.length) { event.preventDefault(); return; }
  const first = buttons[0], last = buttons[buttons.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
}
</script>
<style scoped>
.game-rematch-dialog-backdrop {
  position: absolute; inset: 0; z-index: 7; display: flex; align-items: center; justify-content: center;
  padding: calc(var(--cb-safe-top) + 20px) 20px calc(var(--cb-safe-bottom) + 20px);
  background: rgba(5,8,3,.52);
}
.game-rematch-dialog {
  display: flex; flex-direction: column; gap: 14px; width: min(100%, 360px); max-height: 100%;
  overflow-y: auto; padding: 24px; border: 1px solid var(--cb-lime-border); border-radius: 24px;
  background: var(--cb-surface); box-shadow: 0 12px 50px rgba(0,0,0,.6); text-align: center;
}
.game-rematch-dialog__eyebrow { color: var(--cb-lime); font-size: 12px; text-transform: uppercase; letter-spacing: .1em; }
.game-rematch-dialog h2 { font-size: 24px; line-height: 1.2; overflow-wrap: anywhere; }
.game-rematch-dialog p { color: var(--cb-text-2); font-size: 14px; }
</style>
